import { Box, styled, Typography } from '@mui/material';

export const PageHeading = styled(Typography)`
  margin-bottom: 12px;
`;

export const SubHeading = styled(Typography)(
  ({ theme }) => `
    color: ${theme.palette.brand.charcoal};
    padding-bottom: 17px;
    border-bottom: 1px solid ${theme.palette.brand.charcoal}
`,
);

export const VersionCard = styled('span')(
  ({ theme }) => `
    margin: 24px 24px 20px 0;
    padding: 20px;
    width: 100%;
    border-radius: 4px;
    max-width: 486px;
    background-color: ${theme.palette.brand.whitesmoke};
    display: block;

    > p:first-of-type {
        font-weight: 500;
        margin-bottom: 24px;
        color: ${theme.palette.common.black}
    }
`,
);

export const CardWrapper = styled(Box)`
  display: flex;
`;
